<template>
  <div class="admin-setting">
    <div>
      白名单
    </div>
    <div class="form-line">
      <div class="label">电话白名单</div>
      <div class="value">
        <el-input @input="changeWhiteListMobile" type="textarea" autosize v-model="form.whiteList.value"
          v-if="form.whiteList.edit"></el-input>
        <p v-else>{{ result.white_list_mobile }}</p>
      </div>
      <div class="btn">
        <template v-if="form.whiteList.edit">
          <div @click="saveFormWhiteList">保存</div>
          <div @click="form.whiteList.edit = false">取消</div>
        </template>
        <el-button type="primary" size="small" class="editBtn" @click="editFormWhiteList" v-else>修改</el-button>
      </div>
    </div>



  </div>
</template>

<script>
import {

  handleSetting
} from "@/utils/axios"
import { Base64 } from 'js-base64'
import { isPhone } from '@/utils'

export default {
  name: 'adminSetting',
  data () {

    return {
      form: {
        whiteList: {
          edit: false,
          value: ""
        }
      },
      result: {
        white_list_mobile: ""
      }
    }
  },
  watch: {

  },
  created () { },
  mounted () {
    this.$nextTick(() => {
      this.getList();
    })
  },
  methods: {
    // 获取列表
    getList () {
      const data = {
        act: ""
      }
      handleSetting(data).then(res => {
        if (res.code == 200) {
          const resData = JSON.parse(Base64.decode(res.data))
          this.form.whiteList.value = resData.white_list_mobile
          this.result = resData
        }

      })
    },
    saveFormWhiteList () {
      if (this.validPhone(this.form.whiteList.value)) {
        const data = {
          act: "white_list_mobile",
          text: this.form.whiteList.value
        }
        handleSetting(data).then(res => {
          if (res.code == 200) {
            this.form.whiteList.edit = false
            this.getList()
          } else {
            this.$myAlert({
              type: 'fail',
              content: res.msg
            });
          }
        })
      } else {
        this.$myAlert({
          type: 'fail',
          content: '手机号码格式不正确，请重新输入'
        });
      }


    },
    validPhone (str) {
      if (str) {
        const arr = str.split(',')
        const bol = arr.some((item) => !isPhone(item))

        return !bol
      } else {
        return true
      }

    },
    changeWhiteListMobile (val) {
      this.form.whiteList.value = val.replace(/[^\,\d]/g, "")
    },
    editFormWhiteList () {
      this.form.whiteList.edit = true
      this.form.whiteList.value = this.result.white_list_mobile
    }
  }
}
</script>

<style scoped></style>
<style lang="scss" scoped>
.admin-setting {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 12px;
  color: #838383;

  >div {
    padding: 10px 6px;
  }

  .form-line {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: 1px solid #00000014;
    line-height: 33px;

    &:hover {
      background-color: #00000008;
    }

    >div {
      flex: 0 0 atuo;
      padding: 0 12px;

    }

    .value {
      flex: 1;

    }

    .btn {
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      >div {
        padding: 0px 4px;
        cursor: pointer;
        color: #6883FB;
        width: fit-content;
      }
    }

    .label {
      color: #000;
      font-weight: bold;
      min-width: 140px;
      text-align: left;
      line-height: 33px;
      padding: 0;
    }
  }
}
</style>